import React from 'react';
import styled from 'styled-components';

import { ContentSection, ColumnBlock } from '../../layout/components/';

const AwardItem = styled(ColumnBlock)`
  margin-bottom: 5.625rem;
  align-items: center;
  justify-content: center;

  figure {
    box-sizing: border-box;
    width: 100%;
    padding: 0 3.75rem;
    text-align: center;

    img {
      width: 100%;
      height: auto;
      margin: 0 auto;
    }
  }
`;

const awards = [
  {
    url: '2020_bestplacestowork.png',
    width: 208,
  },
  {
    url: '2019_bestplacestowork.png',
    width: 208,
  },
  {
    url: '2018_bestplacestowork.png',
    width: 208,
  },
  {
    url: '2017_bestplacestowork.png',
    width: 208,
  },
  {
    url: '2018_tiga.png',
    width: 333,
  },
  {
    url: '2017_tiga.png',
    width: 333,
  },
  {
    url: '2016_tiga.png',
    width: 332,
  },
  {
    url: '2015_tiga.png',
    width: 333,
  },
  {
    url: 'mishcon.png',
    width: 294,
  },
  {
    url: '2016_develop.png',
    width: 330,
  },
  {
    url: '2015_develop.png',
    width: 314,
  },
  {
    url: '2014_develop.png',
    width: 316,
  },
  {
    url: 'theeuropas.png',
    width: 314,
  },
  {
    url: '2014_tabbyawards.png',
    width: 213,
  },
  {
    url: 'futurefifty.png',
    width: 207,
  },
];

const AwardsSection = props => {
  return (
    <ContentSection title="Awards" noMargin>
      {awards.map((award, index) => (
        <AwardItem key={index}>
          <figure>
            <img src={`${process.env.PUBLIC_URL}/img/awards/${award.url}`} alt="" style={{maxWidth:`${award.width}px`}} />
          </figure>
        </AwardItem>
      ))}
    </ContentSection>
  );
};

export default AwardsSection;



// WEBPACK FOOTER //
// ./src/modules/pages/components/AwardsSection.js